// What a Firebase failure may say in a log line: its code, or the kind of
// the error. Never its message, which can quote the email.

export function codeOf(error: unknown): string {
  if (typeof error === "object" && error !== null && "code" in error && typeof error.code === "string") return error.code;
  return error instanceof Error ? error.name : typeof error;
}
